export default "__VITE_ASSET__DlbuSE3N__"